module.exports = __webpack_public_path__ + "static/media/tombstone-alt.10eaea2e.svg";